import React from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { ScoreTable } from './ScoreTable'
import { NewSatScoreTable } from './NewSatScoreTable'
import { GoalsRecommendation } from './GoalsRecommendation'
import { CollegeListForGoals } from './CollegeListForGoals'
import { useParams } from 'react-router-dom'

const StudentGoalQuestions = () => {
	const { user } = useAuth()
	const { studentId } = useParams()
	const [activeTab, setActiveTab] = React.useState('sat')
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	if (!effectiveStudentId) {
		return (
			<div className="text-center p-5">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		)
	}

	const isStudent = user?.role === 'Student911' || user?.role === 'Student12'

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab)
	}

	return (
		<StudentTopMenuLayout activeMenu="GoalGrades" pageName="Goal Questions">
			<div className="col-md-12">
				<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
					<div className="card-body">
						<Nav tabs>
							<NavItem>
								<NavLink
									className={activeTab === 'sat' ? 'active' : ''}
									onClick={() => toggle('sat')}
									style={{ cursor: 'pointer' }}
								>
									SAT
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={activeTab === 'newSat' ? 'active' : ''}
									onClick={() => toggle('newSat')}
									style={{ cursor: 'pointer' }}
								>
									New SAT
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={activeTab === 'goals' ? 'active' : ''}
									onClick={() => toggle('goals')}
									style={{ cursor: 'pointer' }}
								>
									GOALS
								</NavLink>
							</NavItem>
						</Nav>
						<TabContent activeTab={activeTab} className="mt-3">
							<TabPane tabId="sat">
								<ScoreTable slug={effectiveStudentId} isProfile={false} plain={true} />
							</TabPane>
							<TabPane tabId="newSat">
								<NewSatScoreTable slug={effectiveStudentId} isProfile={false} plain={true} />
							</TabPane>
							<TabPane tabId="goals">
								<GoalsRecommendation slug={effectiveStudentId} isStudent={isStudent} isProfile={false} plain={true} />
							</TabPane>
						</TabContent>
					</div>
				</div>
				{!isInstructorView && <CollegeListForGoals studentId={effectiveStudentId} />}
			</div>
		</StudentTopMenuLayout>
	)
}

export { StudentGoalQuestions }
